import {MILLISECONDS_PER_DAY} from '../constants'

export const round = (value, decimalPlaces) => {
  return parseFloat(
    Math.round(value * Math.pow(10, decimalPlaces)) /
      Math.pow(10, decimalPlaces),
  ).toFixed(decimalPlaces)
}

export const textSize = (text, font) => {
  this.element = document.createElement('canvas')
  this.context = this.element.getContext('2d')
  this.context.font = font
  return {
    width: this.context.measureText(text).width,
    height: parseInt(this.context.font, 10),
  }
}

export const addDaysToDate = (orgDate, days) => {
  const date = orgDate instanceof Date ? orgDate : new Date(orgDate)
  return new Date(date.getTime() + MILLISECONDS_PER_DAY * days)
}

export const daysBetween = (date1, date2) => {
  //Get 1 day in milliseconds
  var oneDay = MILLISECONDS_PER_DAY

  // Convert both dates to milliseconds
  var date1MS =
    date1 instanceof Date ? date1.getTime() : new Date(date1).getTime()
  var date2MS =
    date2 instanceof Date ? date2.getTime() : new Date(date2).getTime()

  // Calculate the difference in milliseconds
  var differenceMS = date2MS - date1MS

  // Convert back to days and return
  return Math.round(differenceMS / oneDay)
}



// WEBPACK FOOTER //
// ./src/helpers/math.js